import { Link } from "react-router-dom";
import { Waves } from "lucide-react";

export const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="border-t border-white/10 mt-24 py-10 bg-[#000000]"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-slate-400">
                <div className="flex items-center gap-2">
                    <Waves className="w-4 h-4 text-teal-400" />
                    <span className="font-display font-semibold text-white">Deep Current</span>
                    <span className="text-slate-500">© {new Date().getFullYear()}</span>
                </div>
                <div className="flex items-center gap-5">
                    <Link to="/games" className="hover:text-white">Games</Link>
                    <Link to="/team" className="hover:text-white">Team</Link>
                    <Link to="/about" className="hover:text-white">About</Link>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
